"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthController = function () {
  function AuthController(AuthService, $injector) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AuthController);
    this.email = "";
    this.password = "";
    this.userService = AuthService;
    this.$injector = $injector;
  }

  (0, _createClass3.default)(AuthController, [{
    key: "login",
    value: function login($event) {
      $event.preventDefault();
      var result = this.userService.login(this.email, this.password);
      if (!result) {
        this.error = "Wrong Credentials";
      } else {
        this.$injector.get('$state').go('app');
      }
      console.log('login', this);
    }
  }]);
  return AuthController;
}();

// WEBPACK FOOTER //


exports.default = AuthController;


/** WEBPACK FOOTER **
 ** ./client/app/common/auth/auth.controller.js
 **/